/** Keep the original classifier input; truncating or replacing it can turn
 * automation into apparently regular traffic. Missing/invalid values stay unknown. */
export const MAX_ANALYTICS_USER_AGENT_LENGTH = 2048;

export function isValidAnalyticsUserAgent(value: unknown): value is string {
  if (typeof value !== "string" || value.length > MAX_ANALYTICS_USER_AGENT_LENGTH || !value.trim()) return false;
  for (let index = 0; index < value.length; index++) {
    const code = value.charCodeAt(index);
    if (code < 32 || code === 127) return false;
  }
  return true;
}
